import type { TemplateDetailedResourceReadV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import type { TemplateDetailedResource } from '../../models/templateResource.model';
import { mapArtifactType } from './deviceManagementArtifacts.mapper';

export function mapTemplateByIdResponse(response: TemplateDetailedResourceReadV2Api): TemplateDetailedResource {
  return {
    name: response.name,
    id: response.id,
    checksum: response.checksum,
    type: mapArtifactType(response.type),
    componentType: response.componentType as TemplateDetailedResource['componentType'],
    createdBy: response.createdBy,
    creationDate: response.creationDate,
    description: response.description,
    fileName: response.fileName,
    mimeType: response.mimeType,
    size: response.size,
    parameter: response.parameter as TemplateDetailedResource['parameter'],
    templateFileId: response.templateFileId,
    targetLocation: response.targetLocation,
    templateFileName: response.templateFileName,
    templateFileVersion: response.templateFileVersion,
  } satisfies TemplateDetailedResource;
}
